/**
 * useCalScheduling — per-user gate for the Cal.diy scheduling pilot.
 *
 * Mirrors the Dialpad per-user onSnapshot pattern: reads users/{uid} and
 * exposes whether the calSchedulingEnabled flag is set, plus the user's
 * default public booking URL (mirrored there by BookingPagesManager for
 * merge fields).
 *
 * All scheduling UI (settings tab, drawer actions, campaign trigger group,
 * launcher tile) must stay invisible unless `enabled` is true.
 */

import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../utils/init-firebase';
import { useAuth } from '../contexts/AuthContext';

export default function useCalScheduling() {
  const { currentUser } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [defaultBookingUrl, setDefaultBookingUrl] = useState('');

  useEffect(() => {
    if (!currentUser?.uid) return undefined;
    const userRef = doc(db, 'users', currentUser.uid);
    const unsubscribe = onSnapshot(userRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setEnabled(data.calSchedulingEnabled === true);
        setDefaultBookingUrl(data.defaultBookingUrl || '');
      } else {
        setEnabled(false);
        setDefaultBookingUrl('');
      }
    });
    return () => unsubscribe();
  }, [currentUser?.uid]);

  return { enabled, defaultBookingUrl };
}
